import { Button, Col, Modal, Row } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

import ButtonOperation from 'components/ButtonOperation';
import GetLabel from 'DisplayFramework/components/GetLabel';
import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';

type ConfirmModalProps = {
  visible: boolean;
  onConfirm: (item?: any) => void;
  onCancel?: () => void;
  onSeeMore?: () => void;
  message: any;
  status: string;
  description?: any;
  onlyCancel?: boolean;
  onlyConfirm?: boolean;
  onlySeeMore?: boolean;
  className?: string;
  Cancelcomcode?: string;
  Confirmcomcode?: string;
  SeeMorecomcode?: string;
  padding?:string;
  confirmLoading?: boolean;
  showOfferInput?: boolean;
  prcode?:string;
  offerid?: number;
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  onSeeMore,
  message,
  status,
  description,
  onlyCancel,
  onlyConfirm,
  onlySeeMore,
  className,
  Cancelcomcode,
  Confirmcomcode,
  SeeMorecomcode,
  padding,
  confirmLoading = false,
  showOfferInput = false,
  prcode,
  offerid
}) => {
  const importAll = (r: any) => {
    let images: any = {};
    r.keys().map((item: any, index: any) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  };

  const images: any = importAll(
    require.context('/src/assets/', false, /\.(png|jpg|jpe?g|svg)$/)
  );
  let icon;
  if (status === 'success') {
    icon = images['success.png'];
  } else if (status === 'error') {
    icon = images['warning.png'];
  } else if (status === 'progress') {
    icon = images['EnCoursEnvoyé.png'];
  } else if (status === 'warning') {
    icon = images['error.png'];
  }

  const [offeridfilter, setOfferidfilter] = useState('' as any);

  return (
    <Modal
      width={400}
      className={`modal-sfs display-none ${className}`}
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={[
        <Row justify={'end'} style={{ marginTop: 13 }} className='btn-product-creat'>
          {onlySeeMore && onlyConfirm ? (
            <Row>
              <Col>
                {/* <Button
                  
                >
                  <GetLabel label= className='color-gray1' />
                </Button> */}
                <ButtonOperation
                  className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 "
                  onClick={onSeeMore}
                  comcode={SeeMorecomcode ?? 'seeMore'}
                />

              </Col>

              <Col>
                <ButtonOperation type="primary"
                  htmlType="submit"
                  className="ut-submit-btn ml-4"
                  onClick={() => {
                    if (showOfferInput) {
                      onConfirm(offeridfilter);
                      setOfferidfilter(''); 
                    } else {
                      onConfirm();
                    }
                    
                  }}
                  loading={confirmLoading}
                  iconPosition="end"
                  comcode={Confirmcomcode ?? "Valider"} />
              </Col>


            </Row>
          ) : onlyCancel ? (
            <Button
              className="ut-reset-btn mr-4"
              onClick={onCancel}
              disabled = {confirmLoading}
            >
              <GetLabel label={Cancelcomcode ?? 'cancel'} />
            </Button>
          ) :
            onlyConfirm ? (
              <Button
                type="primary"
                htmlType="submit"
                className="ut-submit-btn"
                onClick={() => {
                  if (showOfferInput) {
                    onConfirm(offeridfilter);
                    setOfferidfilter(''); 
                  } else {
                    onConfirm();
                  }
                }}
                loading={confirmLoading}
                iconPosition="end"
              >
                <GetLabel label={Confirmcomcode ?? 'Valider'} />
              </Button>
            )
              : (
                <Row>
                  <Col>
                    <Button
                      className="ut-reset-btn"
                      onClick={() => {
                        onCancel?.();
                        if (showOfferInput) {
                          setOfferidfilter(''); 
                        } 
                        
                      }}  
                      disabled = {confirmLoading}
                    >
                      <GetLabel label={Cancelcomcode ?? "cancel"} />
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="ut-submit-btn ml-4"
                      onClick={() => {
                        if (showOfferInput) {
                          onConfirm(offeridfilter);
                          setOfferidfilter(''); 
                        } else {
                          onConfirm();
                        }
                      }}
                      loading={confirmLoading}
                      iconPosition="end"
                    >
                      <GetLabel label={Confirmcomcode ?? "Valider"} />
                    </Button>
                  </Col>

                </Row>
              )}
        </Row>,
      ]}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          padding:padding
        }}
      >
        <img
          src={icon}
          style={{
            width: 125,
            height: 125,
          }}
        />
        <p className="font-weight-500 font-size-24">{message}</p>
        <p className="font-weight-500 font-size-15 mt-2">{description}</p>
        {showOfferInput && (
          <div style={{ width: '100%' }}>
            <OfferInput
              allData
              showPlaceholder 
              value={offeridfilter}
              params={{
                prcode: prcode,
                mgid: Number(localStorage.getItem('mgid')),
                offerid: offerid
              }}
              onSelect={(e) => {
                setOfferidfilter(e);
              }}
              onChange={(e) => {
               setOfferidfilter(e);
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmModal;
